import React, { useEffect, useMemo, useState } from 'react';
import styles from '../../../styles/automation/nlpautomation.module.scss';
import { fetchMCPToolsList, getExecutionRecordSteps } from '../../../utils/api';
import { getVariableListData } from '../../../utils/api/Variable_apis';
import { STATUS } from '../../../utils/api/sharedfunction';
import ExecutionSteps from '../common/ExecutionSteps';
import NoPlanFound from './NoPlanFound';
import { setVariablesList, setVariablesListDescriptions, setFileSuggestions } from '../../../features/replayslice';
import { useDispatch } from 'react-redux';
import { getExecutionFilesForDropdown } from '../../../utils/api/executionFileApis';

export default function NLPAutomation({ testCaseId }) {
    const [isLoading, setIsLoading] = useState(true);
    const [planData, setPlanData] = useState(null);   
    const [dynamicResult, setDynamicResult] = useState(null);
    const dispatch = useDispatch();

    // Fetch variables list on mount
    useEffect(() => {
        let isMounted = true;
        
        const fetchVariables = async () => {
            try {
                const response = await getVariableListData();
                if (isMounted && response.status === STATUS.SUCCESS) {
                    dispatch(setVariablesList(response.data?.data || []));
                    dispatch(setVariablesListDescriptions(response.data?.description || {}));
                }
            } catch (error) {
                console.error('Error fetching variables:', error);
            }
        };

        const fetchFiles = async () => {
            const response = await getExecutionFilesForDropdown();
            if (response.status === STATUS.SUCCESS) {
                dispatch(setFileSuggestions(response.data?.suggestions || []));
            }
        };

        fetchVariables();
        fetchFiles();
        return () => {
            isMounted = false;
        };
    }, [dispatch]);

    useEffect(() => {
        (async () => {
            if(!testCaseId) return;
            setIsLoading(true);
            const executionResponse = await getExecutionRecordSteps({testCaseId: testCaseId});
            if (executionResponse.status === 1 && executionResponse.data && executionResponse.data.plan && executionResponse.data.plan.steps && executionResponse.data.plan.steps.length > 0) {
                setPlanData(executionResponse.data.plan.steps);
                setDynamicResult(
                    executionResponse.data.plan?.dynamicResults
                    ??
                    executionResponse.data.plan.metadata?.dynamicResult
                    ?? null
                );
            }
            setIsLoading(false);
        })();
    }, [testCaseId]);

    return (
        <>
            {
                isLoading ?
                <div className={styles.loadingContainer}>
                    <div className={styles.loadingSpinner} />
                </div>
                : 
                <>
                    {planData && planData.length > 0 ? 
                        <div className={styles.nlpAutomationContainer}>
                            <ExecutionSteps steps={planData} testCaseId={testCaseId} dynamicResult={dynamicResult} />
                        </div>
                        :
                    <NoPlanFound testCaseId={testCaseId} /> 
                   }
                </>
            }
        </>
    );
}